import { produce } from "immer";
import { ImmerActionInput, MenuItemStateType } from "../types";
import {
  PRODUCTS_FETCH_DONE,
  PRODUCTS_FETCH_START,
} from "../constants/actionTypes";
import { MenuItemAction, ProductsFetchDoneAction } from "../types/product";

export const initialState: MenuItemStateType = {
  productsLoading: false,
  products: [],
  heroSectionList: [],
  heroFilter: "",
};

const getAllProductsDone = ({
  action,
  draft,
}: ImmerActionInput<ProductsFetchDoneAction, MenuItemStateType>) => {
  draft.productsLoading = false;
  draft.products = action.payload || [];
};

export default produce((draft: MenuItemStateType, action: MenuItemAction) => {
  switch (action.type) {
    case PRODUCTS_FETCH_START:
      draft.productsLoading = true;
      break;
    case PRODUCTS_FETCH_DONE:
      getAllProductsDone({ action, draft });
      break;
    default:
  }
}, initialState);
